import { useState } from 'react';
import Link from '@/components/utilities/SmartLink';
import { getImagePath } from '@/utils/images';
import { useEbookLabels } from '@/utils/ebook-labels';

const DownloadIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path d="M9 17.75C8.9 17.75 8.81 17.73 8.71 17.69C8.43 17.58 8.25 17.3 8.25 17V11C8.25 10.59 8.59 10.25 9 10.25C9.41 10.25 9.75 10.59 9.75 11V15.19L10.47 14.47C10.76 14.18 11.24 14.18 11.53 14.47C11.82 14.76 11.82 15.24 11.53 15.53L9.53 17.53C9.39 17.67 9.19 17.75 9 17.75Z" />
    <path d="M8.99994 17.7495C8.80994 17.7495 8.61994 17.6795 8.46994 17.5295L6.46994 15.5295C6.17994 15.2395 6.17994 14.7595 6.46994 14.4695C6.75994 14.1795 7.23994 14.1795 7.52994 14.4695L9.52994 16.4695C9.81994 16.7595 9.81994 17.2395 9.52994 17.5295C9.37994 17.6795 9.18994 17.7495 8.99994 17.7495Z" />
    <path d="M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H14C14.41 1.25 14.75 1.59 14.75 2C14.75 2.41 14.41 2.75 14 2.75H9C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V10C21.25 9.59 21.59 9.25 22 9.25C22.41 9.25 22.75 9.59 22.75 10V15C22.75 20.43 20.43 22.75 15 22.75Z" />
    <path d="M22 10.7505H18C14.58 10.7505 13.25 9.42048 13.25 6.00048V2.00048C13.25 1.70048 13.43 1.42048 13.71 1.31048C13.99 1.19048 14.31 1.26048 14.53 1.47048L22.53 9.47048C22.74 9.68048 22.81 10.0105 22.69 10.2905C22.57 10.5705 22.3 10.7505 22 10.7505ZM14.75 3.81048V6.00048C14.75 8.58048 15.42 9.25048 18 9.25048H20.19L14.75 3.81048Z" />
  </svg>
);

const NewsletterForm = ({ tagValue }) => {
  const labels = useEbookLabels();
  const [email, setEmail] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);

  const onSubmit = (e) => {
    e.preventDefault();
    setIsSubmitted(true);

    if (email && typeof window !== 'undefined' && window.lhi) {
      window.lhi('identify', {
        email: email,
        subscribe: ['newsletters']
      });

      if (tagValue) {
        window.lhi('addTag', {
          name: 'ebook',
          data: {
            id: tagValue,
            date: {
              datatype: 'datetime',
              value: new Date().toISOString()
            }
          }
        });
      }
    }
  };

  if (isSubmitted) {
    return <p className="text-brand-500 mt-3 text-sm font-medium">{labels.newsletterSubmittedText}</p>;
  }

  return (
    <form onSubmit={onSubmit} className="mt-3 flex flex-col gap-2" noValidate>
      <input
        type="email"
        name="email"
        required
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder={labels.newsletterPlaceholder}
        className="bg-grey-50 border-grey-200 text-grey-900 placeholder:text-grey-500 focus:border-grey-900 w-full rounded-full border px-4 py-2.5 text-left text-sm transition-colors outline-none"
      />
      <button
        type="submit"
        className="bg-brand-400 hover:bg-brand-500 w-full rounded-full px-5 py-2.5 text-sm font-medium text-white transition-colors"
      >
        {labels.newsletterButtonLabel}
      </button>
    </form>
  );
};

const EbookSidebarDownload = ({ text, pdfLabel, pdfFile, note, newsletterText, tagName, slug }) => {
  const pdfUrl = pdfFile?.url ? getImagePath(pdfFile) : null;
  const tagValue = tagName || slug;

  if (!pdfUrl && !newsletterText) return null;

  return (
    <div className="border-grey-200 rounded-2xl border px-6 py-5 text-center">
      {pdfUrl && (
        <>
          <div className="bg-brand-50 text-brand-400 mx-auto mb-3 flex h-10 w-10 items-center justify-center rounded-full">
            <DownloadIcon />
          </div>
          {text && <p className="text-grey-600 mb-3 text-sm">{text}</p>}
          <Link
            href={pdfUrl}
            target="_blank"
            rel="noopener"
            className="bg-brand-400 hover:bg-brand-500 flex w-full items-center justify-center rounded-full px-5 py-3 text-sm font-medium text-white transition-colors"
          >
            {pdfLabel || 'Stáhnout PDF'}
          </Link>
        </>
      )}

      {newsletterText && (
        <>
          {pdfUrl && <hr className="border-grey-200 my-5" />}
          <p className="text-grey-600 text-sm leading-relaxed">{newsletterText}</p>
          <NewsletterForm tagValue={tagValue} />
        </>
      )}

      {note && <p className="text-grey-400 mt-3 text-xs">{note}</p>}
    </div>
  );
};

export default EbookSidebarDownload;
